"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M23 3H1v18h22zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6z"
}), 'PhotoSizeSelectActualSharp');